<template>
  <q-dialog
    :visible="isVisible"
    title="添加SKU"
    width="70%"
    :innerScroll="false"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-row>
      <div class="search-row">
        <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
          <el-form-item label="SKU编码：" prop="skuCode">
            <el-input v-model.trim="searchForm.skuCode" placeholder="请输入编码"></el-input>
          </el-form-item>
          <el-form-item label="SKU名称：" prop="skuName">
            <el-input v-model.trim="searchForm.skuName" placeholder="请输入名称"></el-input>
          </el-form-item>
        </el-form>
        <div class="search-buttons">
          <el-button size="mini" type="primary" @click="onSearch">搜索</el-button>
          <el-button size="mini" class="orange-btn" @click="onReset">重置</el-button>
        </div>
      </div>
    </el-row>
    <el-row type="flex" justify="start">
      <el-col :span="12">
        <el-container class="table-container">
          <el-col :offset="1">待选列表</el-col>
          <el-main>
            <el-table :data="skuTables.records" :header-cell-style="{ backgroundColor: '#FAFAFA' }" style="width: 100%" :height="250">
              <el-table-column prop="code" label="SKU编码"> </el-table-column>
              <el-table-column prop="name" label="SKU名称" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="addToSelected(scope.row)">添加</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer style="text-align: right">
            <el-pagination
              @size-change="onDialogSizeChange"
              @current-change="onDialogCurrentChange"
              :current-page="skuTables.pageNum"
              :page-sizes="[10, 30]"
              :page-size="skuTables.pageSize"
              :total="skuTables.total"
              layout="total, prev, pager, next"
            >
            </el-pagination>
          </el-footer>
        </el-container>
      </el-col>

      <el-col :span="12">
        <el-container class="table-container">
          <el-col :offset="1">已选列表</el-col>
          <el-main>
            <el-table :data="selectedSkuTables.records" :header-cell-style="{ backgroundColor: '#FAFAFA' }" :height="250" style="width: 100%">
              <el-table-column prop="code" label="SKU编码"> </el-table-column>
              <el-table-column prop="name" label="SKU名称" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="removeFromSelected(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer style="text-align: right">
            <el-pagination
              @size-change="onFinalSizeChange"
              @current-change="onFinalCurrentChange"
              :current-page="selectedSkuTables.pageNum"
              :page-sizes="[10, 30]"
              :page-size="selectedSkuTables.pageSize"
              :total="selectedSkuTables.total"
              layout="total, prev, pager, next"
            >
            </el-pagination>
          </el-footer>
        </el-container>
      </el-col>
    </el-row>
  </q-dialog>
</template>

<script>
export default {
  name: 'SelectSkuDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 已存在的 SKU 列表（用于过滤）
    existingSkus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      searchForm: {
        skuCode: '',
        skuName: ''
      },
      skuTables: {
        records: [],
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      selectedSkuTables: {
        records: [],
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.selectedSkuTables.records = []
      this.searchForm.skuCode = ''
      this.searchForm.skuName = ''
      this.getSku()
    },
    onCancel() {
      this.isVisible = false
    },
    onConfirm() {
      this.$emit('confirm', this.selectedSkuTables.records)
      this.isVisible = false
    },
    onSearch() {
      this.skuTables.pageNum = 1
      this.getSku()
    },
    onReset() {
      this.searchForm.skuCode = ''
      this.searchForm.skuName = ''
      this.onSearch()
    },
    getSku() {
      const { skuCode, skuName } = this.searchForm
      let param = {
        pageNum: this.skuTables.pageNum,
        pageSize: this.skuTables.pageSize,
        filterData: {
          skuCode: skuCode,
          skuName: skuName
        }
      }
      if (this.existingSkus.length > 0) {
        let arr = this.existingSkus.map((x) => x.code)
        param.filterData.codeList = arr
      }
      this.$q.spu
        .listGoods({
          data: param
        })
        .then((data) => {
          if (data.code == 200) {
            this.skuTables = data.data
          }
        })
    },
    addToSelected(row) {
      this.selectedSkuTables.records.push(row)
      let arr = []
      for (let i = 0; i < this.skuTables.records.length; i++) {
        if (this.skuTables.records[i].id != row.id) {
          arr.push(this.skuTables.records[i])
        }
      }
      this.skuTables.records = arr
    },
    removeFromSelected(row) {
      let arr = []
      for (let i = 0; i < this.selectedSkuTables.records.length; i++) {
        if (this.selectedSkuTables.records[i].id != row.id) {
          arr.push(this.selectedSkuTables.records[i])
        }
      }
      this.selectedSkuTables.records = arr
      if (this.skuTables.records.length < this.skuTables.pageSize) {
        this.skuTables.records.push(row)
      }
    },
    onDialogSizeChange(pageSize) {
      this.skuTables.pageSize = pageSize
      this.skuTables.pageNum = 1
      this.getSku()
    },
    onDialogCurrentChange(pageNum) {
      this.skuTables.pageNum = pageNum
      this.getSku()
    },
    onFinalSizeChange(pageSize) {
      this.selectedSkuTables.pageSize = pageSize
      this.selectedSkuTables.pageNum = 1
    },
    onFinalCurrentChange(pageNum) {
      this.selectedSkuTables.pageNum = pageNum
    }
  }
}
</script>

<style lang="stylus" scoped>
.search-row
  display flex
  justify-content space-between
  align-items center
  width 100%
  .search-buttons
    flex-shrink 0
</style>
